document.addEventListener('DOMContentLoaded', () => {

    // --- HÉR ERU NÝJU GÖGNIN ÞÍN ---
    const slideDecks = [
        {
            id: 'ad-setja-ser-markmid',
            title: 'Að setja sér markmið',
            description: 'Lærðu aðferðir til að setja þér skýr, raunhæf og hvetjandi markmið til að ná árangri.',
            category: 'Hugur',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/Ad_setja_ser_markmid_-_Glaerupakki.png?v=1752323858',
            fileUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/Ad_setja_ser_markmid_-_Glaerupakki.pdf?v=1752319997' 
        },
        {
            id: 'jakvaett-hugafar',
            title: 'Jákvætt hugarfar',
            description: 'Uppgötvaðu hvernig þú getur þjálfað upp jákvætt hugarfar til að takast á við áskoranir og auka vellíðan.',
            category: 'Hugur',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/AJakvaett_hugarfar_-_Glaerupakki.png?v=1752323925',
            fileUrl: 'https://cdn.shopify.com/s/files/1/0763/1306/7771/files/AJakvaett_hugarfar_-_Glaerupakki.pdf?v=1752319995'
        }
    ];

    const grid = document.getElementById('deck-grid');
    const modalOverlay = document.getElementById('deck-modal-overlay');
    const modalBody = document.getElementById('modal-deck-body');
    const modalCloseButton = modalOverlay.querySelector('.modal-close-button');
    const categoryFiltersContainer = document.getElementById('category-filters');

    function populateFilters() {
        const categories = ['all', ...new Set(slideDecks.map(deck => deck.category))];
        if (!categoryFiltersContainer) return;
        categoryFiltersContainer.innerHTML = categories.map(category => 
            `<button class="tab-button ${category === 'all' ? 'active' : ''}" data-filter="${category}">
                ${category === 'all' ? 'Allir Flokkar' : category}
            </button>`
        ).join('');
    }

    function renderDecks(filter = 'all') {
        if (!grid) return;
        const filteredDecks = filter === 'all' ? slideDecks : slideDecks.filter(d => d.category === filter);

        grid.innerHTML = filteredDecks.map(deck => `
            <div class="deck-card" data-deck-id="${deck.id}" style="background-image: url('${deck.imageUrl}')">
                <div class="deck-overlay">
                    <div class="deck-text">
                        <h3>${deck.title}</h3>
                        <p>${deck.description}</p>
                    </div>
                    <div class="deck-footer">
                        <span class="deck-category-badge">${deck.category}</span>
                        <span class="card-button">Skoða</span>
                    </div>
                </div>
            </div>
        `).join('');
    }

    function openDeckModal(deckId) {
        const deck = slideDecks.find(d => d.id === deckId);
        if (!deck) return;
        modalBody.innerHTML = `<h2>${deck.title}</h2><p>${deck.description}</p><a href="${deck.fileUrl}" target="_blank" class="modal-button">Opna glærupakka <i class="fas fa-arrow-right"></i></a>`;
        modalOverlay.style.display = 'flex';
        setTimeout(() => modalOverlay.classList.add('visible'), 10);
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        modalOverlay.classList.remove('visible');
        setTimeout(() => {
            modalOverlay.style.display = 'none';
            document.body.style.overflow = 'auto';
            modalBody.innerHTML = '';
        }, 400);
    }

    if (categoryFiltersContainer) {
        categoryFiltersContainer.addEventListener('click', e => {
            if (e.target.tagName === 'BUTTON') {
                categoryFiltersContainer.querySelector('.active').classList.remove('active');
                e.target.classList.add('active');
                renderDecks(e.target.dataset.filter);
            }
        });
    }

    if(grid) {
        grid.addEventListener('click', e => {
            const card = e.target.closest('.deck-card');
            if (card) {
                openDeckModal(card.dataset.deckId);
            }
        });
    }

    if(modalCloseButton) {
        modalCloseButton.addEventListener('click', closeModal);
    }
    
    if(modalOverlay) {
        modalOverlay.addEventListener('click', e => {
            if (e.target === modalOverlay) closeModal();
        });
    }

    if(typeof AOS !== 'undefined') {
        AOS.init({ duration: 800, once: true });
    }
    
    populateFilters();
    renderDecks();
    document.body.classList.add('content-visible');
});